// Faint animated soundwave grid behind the trading terminal.
// Two SVG sine paths drift horizontally at different speeds to give a
// techno-grid, "market breathing" feeling.  Kept CSS-only for performance.
export const SoundWaveBackground = () => {
  const wave = (amp, offset) => {
    const points = [];
    for (let x = 0; x <= 3200; x += 40) {
      const y = 100 + Math.sin((x + offset) / 90) * amp;
      points.push(`${x},${y.toFixed(1)}`);
    }
    return `M ${points.join(" L ")}`;
  };

  return (
    <div className="pointer-events-none absolute inset-0 overflow-hidden">
      {/* copper grid */}
      <div className="absolute inset-0 pulse-grid-bg opacity-40" />

      {/* radial vignette */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 20%, rgba(184,115,51,0.10), transparent 55%), radial-gradient(ellipse at 80% 90%, rgba(47,185,153,0.06), transparent 60%)",
        }}
      />

      {/* animated soundwaves */}
      <svg viewBox="0 0 1600 200" preserveAspectRatio="none" className="absolute left-0 right-0 top-1/3 w-[200%] h-64 opacity-[0.13] wave-drift">
        <path d={wave(38, 0)} fill="none" stroke="#B87333" strokeWidth="1" />
        <path d={wave(24, 260)} fill="none" stroke="#B87333" strokeWidth="0.6" />
      </svg>
      <svg viewBox="0 0 1600 200" preserveAspectRatio="none" className="absolute left-0 right-0 top-2/3 w-[200%] h-64 opacity-[0.10] wave-drift-slow">
        <path d={wave(28, 120)} fill="none" stroke="#2FB999" strokeWidth="1" />
        <path d={wave(18, 420)} fill="none" stroke="#2FB999" strokeWidth="0.6" />
      </svg>
    </div>
  );
};
